import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { AlertTriangleIcon } from "lucide-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    companyName: string;
}

export function SwitchWorkspaceDialog({
    isOpen,
    onClose,
    onConfirm,
    companyName,
}: Props) {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[480px]">
                <DialogHeader className="space-y-4">
                    <div className="flex items-center gap-3">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-100">
                            <AlertTriangleIcon className="h-5 w-5 text-yellow-600" />
                        </div>
                        <DialogTitle className="text-xl font-semibold">
                            Proceed to Switch Workspace?
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-base text-gray-600">
                        Are you sure you want to switch to the workspace "{companyName}"?
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex gap-3 sm:gap-3 mt-4">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onClose}
                        className="flex-1"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        onClick={handleConfirm}
                        className="flex-1 bg-yellow-600 hover:bg-yellow-700 text-white"
                    >
                        Switch Now
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}